<template>
  <div id="app" ondragstart="return false;">
    <router-view/>
  </div>
</template>

<script>
  import {WOW} from 'wowjs'
  import {mapGetters} from 'vuex'
  import 'bootstrap/dist/css/bootstrap.min.css'
  import axios from 'axios'
  export default {
    name: 'App',
    data() {
      return {
        screenWidth: 0,
        // lang: 'CN',
        allCount:0,
        url:"http://www.mindpointeye.com.cn:1188/",
        // url:"http://wx.mindpointeye.com.cn:1188/",
      }
    },
    mounted() {
      new WOW({
        live: false
      }).init()
      this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      this.$store.commit('setIsMobile', this.checkIsMobile())
      window.onresize = () => {
        this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        // this.$store.commit('setIsMobile', this.checkIsMobile())
        // console.log(this.screenWidth);
        this.$store.dispatch('setIsMobile',this.checkIsMobile())
      }
      // 初始化路由参数
      this.setLang();
      // this.$nextTick(()=>{
      //    this.getCount();
      //   this.addCount();
      //
      // });
    },
    computed: {
      ...mapGetters(['lang'])
    },
    methods: {
    // count-统计访问量
    addCount () {
      axios({
        method:"post",
        url:this.url+'count/insert'
      }).then().catch()
    },
    //查询访问量
    getCount(){
      axios({
        method:"post",
        url:this.url+"count/queryCount"
      }).then((res)=>{
         if(res.status==200){
           this.allCount=res.data+'';
          //  localStorage.setItem('allCount',this.allCount)
          this.$store.commit('setAllCount',this.allCount);
         }
      }).catch()
    },
      checkIsMobile() {
        if (this.screenWidth < 768) {
          return true
        } else {
          return false
        }
      },
      setLang() {
        // 获取路由参数
        let query = this.$route.query
        if (query.lang) {
          if (query.lang == 'EN') {
            this.$i18n.locale = 'EN'
            this.$store.dispatch('setLang', query.lang)
          } else if(query.lang == 'CN'){
            this.$i18n.locale = 'CN'
            this.$store.dispatch('setLang', query.lang)
          } else if(query.lang == 'RU'){
            this.$i18n.locale = 'RU'
            this.$store.dispatch('setLang', query.lang)
          } else {
            //TODO 其他语言
          }
        }
        if (this.$store.state.lang == 'CN') {
          $(document).attr("title", "全线通：走丝绸之路,创美好明天");
        } else if(this.$store.state.lang == 'EN'){
          $(document).attr("title", "QUANXIANTONG INTERNATIONAL: Take the Silk Road and Create a Better Tomorrow ");
        } else if(this.$store.state.lang == 'RU') {
          $(document).attr("title", "QUANXIANTONG INTERNATIONAL: Идем по Шелковому пути, чтобы создать лучшее завтра ");
        } else {
          //TODO 其他语言
        }
      }

    },
    watch: {
      '$route'() {
        if (this.lang !== this.$route.query.lang) {
          this.setLang()
        }
      },
    },
  }
</script>

<style lang="scss">
body,html{
    height: 100%;
    font-family: Arial, Source Han Sans CN;
}
  body {
    margin: 0;
    padding: 0;
    position: relative;

    .pswp {
      z-index: 5000;
    }
  }

  html {
    font-size: 10px;
  }

  @media screen and (max-width: 320px) {
    html {
      font-size: 12px !important;

      body {
        min-width: 320px;
        overflow-x: scroll;
      }
    }
  }

  @media screen and (max-width: 768px) {
    /*开发手机端时打开*/
    html {
      font-size: 16px;
      body {
        overflow-x: hidden;
      }
    }
  }

  @media screen and (min-width: 768px) and (max-width: 1200px) {
    html {
      font-size: 12px;

      body {
        min-width: 1200px;
        overflow-x: scroll;
      }
    }
  }

  @media screen and (min-width: 1200px) {
    html {
      font-size: 12px;

      body {
        overflow-x: hidden;
      }
    }
  }
    @media screen and (min-width: 1200px) and (max-width: 1400px) {
    html {
      font-size: 12px;
      body {
        overflow-x: hidden;
      }
    }
  }
  @media screen and (min-width: 1400px) {
    html {
      font-size: 16px;
      body {
        overflow-x: hidden;
      }
    }
  }

  #app {
    font-family: Arial, Source Han Sans CN;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width: 100%;
    height: 100%;
  }

  // 播放器显示时滚动条控制显隐性
  .overflowHidden {
    overflow: hidden;
    position: fixed;
  }

  .img-fluid {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue